import Geocode from 'react-geocode';
import { getParametersAction } from '../actions/general.action';

// eslint-disable-next-line import/prefer-default-export
export const setGeoCode = async (data, setGeoCoordinate) => {
  const paramApps = await getParametersAction('license', 'ParameterApiKeyGoogle');
  if (paramApps) {
    const paramApi = paramApps.find((param) => param?.parameterType === 'ParameterApiKeyGoogle');
    const keyApiGMaps = paramApi?.parameterValue;
    if (keyApiGMaps) {
      Geocode.setApiKey(keyApiGMaps);
      Geocode.enableDebug();
      const addressValue = data?.description ? data.description : data;
      if (addressValue !== null) {
        Geocode.fromAddress(addressValue).then(
          (response) => {
            const { location } = response.results[0].geometry;
            if (setGeoCoordinate) {
              setGeoCoordinate(location);
            }
          },
          (err) => {
            console.error('Error cargardo datos geoCode...', err);
            setGeoCoordinate({ lat: null, lng: null });
          },
        );
      }
    }
  }
  return data;
};
